import { DEVICES } from '@constants/global'
import { COLORS } from '@styles/colors'
import { text2XL, textBase, textSM } from '@styles/fonts'
import styled from 'styled-components'

export const InvestorStatistic = styled.section`
  background: ${COLORS.nature[95]};
  padding: 100px 0;

  @media ${DEVICES.mobile} {
    padding: 60px 0;
  }
`

export const InvestorStatisticTitle = styled.h2`
  ${text2XL};
  color: ${COLORS.suburbHeading};
  margin-bottom: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  > div {
    display: flex;
    gap: 16px;
    margin-bottom: 24px;
    justify-content: flex-end;
    ${textBase};
    text-transform: none;
  }

  @media ${DEVICES.mobile} {
    text-align: center;
  }
`

export const Note = styled.p`
  padding-top: 16px;
  display: block;
  font-size: 14px;
  color: ${COLORS.grey[60]};
`
